var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460043)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33335 6.66675L3.33335 33.3334L36.6667 33.3334L36.6667 11.6667L31.6667 6.66675L3.33335 6.66675ZM35 31.6667L35 12.5001L30.8334 8.33341L5.00002 8.33341L5.00002 31.6667L35 31.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 11.6667L28.3334 11.6667L28.3334 15.0001L31.6667 15.0001L31.6667 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6667L21.6667 11.6667L21.6667 15.0001L25 15.0001L25 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667L18.3334 11.6667L18.3334 15.0001L15 15.0001L15 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 11.6667L8.33335 11.6667L8.33335 15.0001L11.6667 15.0001L11.6667 11.6667Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3334L8.33335 18.3334L8.33335 21.6667L11.6667 21.6667L11.6667 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3334L18.3334 18.3334L18.3334 21.6667L15 21.6667L15 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3334L21.6667 18.3334L21.6667 21.6667L25 21.6667L25 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 18.3334L31.6667 18.3334L31.6667 21.6667L28.3334 21.6667L28.3334 18.3334Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 25.0001L31.6667 25.0001L31.6667 28.3334L28.3334 28.3334L28.3334 25.0001Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25.0001L21.6667 25.0001L21.6667 28.3334L25 28.3334L25 25.0001Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 25.0001L18.3334 28.3334L15 28.3334L15 25.0001L18.3334 25.0001Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 28.3334L11.6667 25.0001L8.33335 25.0001L8.33335 28.3334L11.6667 28.3334Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 40 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.98eeaba4adf10fbee1cfea6b0ecd37c1.svg";
export { ForwardRef as ReactComponent };